import { Directive, OnInit, Input, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import * as firebase from 'firebase';


@Directive({
  selector: '[fbSrc]'
})
export class FbSrcDirective implements OnInit {
  @Input() fbKey: string;
  @Input() fbPrefix: string;
  @Input() fbSuffix: string;
  @Input() fbBgImg = false;

  private storageRef;

  constructor(
    private el: ElementRef
  ) {
    this.storageRef = firebase.storage().ref();
  }

  ngOnInit() {
    if (this.fbKey) {
      this.setFbSrc();
    }
  }

  ngOnChanges() {
    if (this.fbKey) {
      this.setFbSrc();
    }
  }

  setFbSrc() {
    this.storageRef.child(`${this.fbPrefix}/${this.fbKey}/${this.fbSuffix}`)
                   .getDownloadURL()
                   .then( url => {
                      let tag = this.el.nativeElement.tagName.toLowerCase();
                      if (tag == 'img') {
                        this.el.nativeElement.src = url;
                      } else if (tag == 'a') {
                        this.el.nativeElement.href = url;
                      } else if (this.fbBgImg) {
                        this.el.nativeElement.style=`background-image: url(${url});`;
                      }
                   });
  }


}



// WEBPACK FOOTER //
// ./src/app/fb-src.directive.ts